// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://dev.graduatetalent.com/api/style.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer__credits p {
  color: rgb(11, 12, 12);
}`, "",{"version":3,"sources":["webpack://./src/app/components/footerAccountApplicationMode/footerAccountApplicationMode.component.css"],"names":[],"mappings":"AAGA;EACE,sBAAsB;AACxB","sourcesContent":["@import url(\"https://dev.graduatetalent.com/api/style.css\");\r\n\r\n\r\n.footer__credits p {\r\n  color: rgb(11, 12, 12);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
